var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close-button w-10 h-10 rounded-full inline-flex items-center justify-center",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('CloseIcon',{staticClass:"m-0 theme:text-secondary"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }